<template>
    <svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 1L13 13.5" stroke="currentColor" />
        <path d="M13 1L0.5 13.5" stroke="currentColor" />
    </svg>
</template>
